import React, { useState, useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../routes/AuthContext";

import Orders from "../components/order/Orders";
import Address from "../components/address/Address";
import Profile from "../components/account/Profile";
import Cart from "../components/cart/Cart";
import Wishlist from "../components/wishlist/Wishlist";

import "./Account.css";

const Account = () => {
  const { isLoggedIn, logout, getCustomerData } = useContext(AuthContext);
  const location = useLocation();

  const [activeSection, setActiveSection] = useState("orders");
  const customerData = getCustomerData();

  /* --------------------------------
     HANDLE NAVIGATION STATE
  -------------------------------- */
  useEffect(() => {
    if (location.state?.section) {
      setActiveSection(location.state.section);
    }
  }, [location.state]);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const renderContent = () => {
    switch (activeSection) {
      case "orders":
        return <Orders />;
      case "address":
        return <Address />;
      case "profile":
        return <Profile />;
      case "cart":
        return <Cart />;
      case "wishlist":
        return <Wishlist />;
      default:
        return <Orders />;
    }
  };

  return (
    <div className="account-container">
      <div className="account-wrapper">
        {/* SIDEBAR */}
        <aside className="account-sidebar">
          {/* USER INFO */}
          <div className="user-info-section">
            <div className="user-avatar">
              {customerData.first_name?.charAt(0).toUpperCase() || "U"}
            </div>
            <div className="user-details">
              <h2>{customerData.first_name || "User"}</h2>
              <p>{customerData.mobile_number}</p>
            </div>
          </div>

          {/* NAVIGATION */}
          <nav className="account-nav">
            <button
              className={`nav-item ${activeSection === "orders" ? "active" : ""}`}
              onClick={() => setActiveSection("orders")}
            >
              <i className="bi bi-bag-check"></i>
              Orders
            </button>

            <button
              className={`nav-item ${activeSection === "cart" ? "active" : ""}`}
              onClick={() => setActiveSection("cart")}
            >
              <i className="bi bi-cart3"></i>
              Cart
            </button>

            <button
              className={`nav-item ${activeSection === "wishlist" ? "active" : ""}`}
              onClick={() => setActiveSection("wishlist")}
            >
              <i className="bi bi-heart"></i>
              Wishlist
            </button>

            <button
              className={`nav-item ${activeSection === "address" ? "active" : ""}`}
              onClick={() => setActiveSection("address")}
            >
              <i className="bi bi-geo-alt"></i>
              Address
            </button>

            <button
              className={`nav-item ${activeSection === "profile" ? "active" : ""}`}
              onClick={() => setActiveSection("profile")}
            >
              <i className="bi bi-person"></i>
              Profile
            </button>
          </nav>

          {/* LOGOUT */}
          <button className="logout-btn" onClick={logout}>
            <i className="bi bi-box-arrow-right"></i>
            Logout
          </button>
        </aside>

        {/* CONTENT */}
        <main className="account-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default Account;
